module.exports = __webpack_public_path__ + "static/media/content1.e71827e6.png";